module.exports = __webpack_public_path__ + "static/media/26UNRWA24.c33508d3.jpg";